// rtlsMapPage.js - Standalone RTLS Map page (primary use: mobile nav)
// On desktop the map is embedded directly in each page. On mobile this
// dedicated route gives the map its own full-screen view.

import React from "react";
import RtlsMap from "./components/rtlsMap";
import "./rtlsMapPage.css";
import "../animation.css";

const RtlsMapPage = () => {
  return (
    <div className="rtls-page page-enter">
      <div className="rtls-page-header">
        <h1>Live Facility Map</h1>
        <p className="rtls-page-subtitle">Real-time RTLS tracking view</p>
      </div>

      {/* RtlsMap uses a spacer + portal pattern - the spacer must live inside
          a container that gives it a well-defined height so the portal card
          can measure and track it correctly. */}
      <div className="rtls-page-body">
        <RtlsMap isHomePage={false} />
      </div>
    </div>
  );
};

export default RtlsMapPage;
